export const environment = {
  production: false,
  imageName: 'constellation.png',
};
